import { render, staticRenderFns } from "./OfferOnBoardDocTable.vue?vue&type=template&id=23f21c82"
import script from "./OfferOnBoardDocTable.vue?vue&type=script&lang=js"
export * from "./OfferOnBoardDocTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports